import { ENDPOINTS } from "utils/endpoints";
import { GET_API_CALL, PATCH_API_CALL } from "utils/services";
import { APIResponseModal } from "utils/modals";
import { UPDATE_SERVICE_PRICING_REDUCER } from "store/actionTypes";
import SHOW_TOAST from "utils/showToast";
import {
  getServicePriceUpdateId,
  mapCategoryTypeItem,
  mapPaginatedResult,
  mapServicePricingItem,
} from "utils/apiMappers";
import {
  SERVICE_CATEGORY,
  hasCategoryTypeFilter,
  toServiceCategory,
} from "utils/serviceCategory";
import {
  getAllCarTypesList,
  getCarpetType,
  getSofaType,
  getTankType,
} from "modules/utilityManagement/action";

/**
 * GET /api/v1/shinology/services/service-price?category&page&limit&categoryTypeId
 * `category` is mandatory: car=0, bike=1, sofa=2, tank=3, carpet=4
 */
export const getServicePricingListing = () => {
  return (dispatch: Function, getState: Function) => {
    const { page, limit, category, categoryTypeId } =
      getState().ServicePricingReducer;
    const resolvedCategory = toServiceCategory(category);

    const queryParams: string[] = [`category=${resolvedCategory}`];
    if (page) queryParams.push(`page=${page}`);
    if (limit) queryParams.push(`limit=${limit}`);
    if (categoryTypeId) queryParams.push(`typeId=${categoryTypeId}`);

    dispatch({
      type: UPDATE_SERVICE_PRICING_REDUCER,
      payload: { loader: true },
    });

        GET_API_CALL(
      ENDPOINTS.SERVICE_PRICING.SERVICE_PRICING_LISTING,
      `?${queryParams.join("&")}`,
      (response: APIResponseModal) => {
        if (response.isSuccess) {
          const dataToSave = mapPaginatedResult(
            response.data,
            mapServicePricingItem,
          );
                    dispatch({
            type: UPDATE_SERVICE_PRICING_REDUCER,
            payload: { ...dataToSave, loader: false },
          });
        } else {
          dispatch({
            type: UPDATE_SERVICE_PRICING_REDUCER,
            payload: { loader: false, result: [] },
          });
        }
      },
    );
  };
};

/**
 * Loads the categoryTypeId dropdown from the type API that matches `category`.
 * car -> getAllCarTypes, sofa -> getSofaType, tank -> getTankType, carpet -> getCarpetType
 */
export const getCategoryTypeOptions = () => {
  return (dispatch: Function, getState: Function) => {
    const { category } = getState().ServicePricingReducer;
    const resolvedCategory = toServiceCategory(category);

    if (!hasCategoryTypeFilter(resolvedCategory)) {
            dispatch({
        type: UPDATE_SERVICE_PRICING_REDUCER,
        payload: { categoryTypes: [] },
      });
      return;
    }

    const saveOptions = (data: any) => {
      const categoryTypes = (data?.result || []).map((item: any) =>
        mapCategoryTypeItem(item, resolvedCategory),
      );
            dispatch({
        type: UPDATE_SERVICE_PRICING_REDUCER,
        payload: { categoryTypes },
      });
    };

    const listParams = { page: 1, limit: 100 };
        if (resolvedCategory === SERVICE_CATEGORY.CAR) {
      dispatch(getAllCarTypesList(listParams, saveOptions));
    } else if (resolvedCategory === SERVICE_CATEGORY.SOFA) {
      dispatch(getSofaType(listParams, saveOptions));
    } else if (resolvedCategory === SERVICE_CATEGORY.TANK) {
      dispatch(getTankType(listParams, saveOptions));
    } else if (resolvedCategory === SERVICE_CATEGORY.CARPET) {
      dispatch(getCarpetType(listParams, saveOptions));
    }
  };
};

export const UpdatePricing = (
  pricings: { id: string; price: number }[],
  callback: Function,
) => {
  return (dispatch: Function) => {
    const dataToSend = {
      pricings: (pricings || [])
        .map((item: any) => ({
          id: getServicePriceUpdateId(item) || String(item?.id || ""),
          price: Number(item?.price),
        }))
        .filter((item) => item.id && Number.isFinite(item.price)),
    };
        dispatch({
      type: UPDATE_SERVICE_PRICING_REDUCER,
      payload: { loader: true },
    });
    PATCH_API_CALL(
      ENDPOINTS.SERVICE_PRICING.UPDATE_SERVICE_PRICING,
      dataToSend,
      (response: APIResponseModal) => {
                if (response.isSuccess) {
          SHOW_TOAST(response?.data?.message, "success");
        }
        dispatch({
          type: UPDATE_SERVICE_PRICING_REDUCER,
          payload: { loader: false },
        });
        callback(response);
      },
    );
  };
};

/**
 * GET /api/v1/shinology/services/service-price for the update modal.
 * Uses a callback so the paginated table listing in Redux is not overwritten.
 * Bike (category=1) omits categoryTypeId; other categories pass the selected type.
 */
export const getServicePricingForUpdate = (
  callback: Function,
  categoryTypeId?: string,
) => {
  return (dispatch: Function, getState: Function) => {
    const { category } = getState().ServicePricingReducer;
    const resolvedCategory = toServiceCategory(category);

    const queryParams: string[] = [
      `category=${resolvedCategory}`,
      `page=1`,
      `limit=100`,
    ];
    if (categoryTypeId) queryParams.push(`typeId=${categoryTypeId}`);

        GET_API_CALL(
      ENDPOINTS.SERVICE_PRICING.SERVICE_PRICING_LISTING,
      `?${queryParams.join("&")}`,
      (response: APIResponseModal) => {
        if (response.isSuccess) {
          const payload = response.data;
          const rawRows = Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload)
              ? payload
              : mapPaginatedResult(payload, (item) => item).result;
          const result = rawRows.map(mapServicePricingItem);
                    callback(result);
        } else {
          callback([]);
        }
      },
    );
  };
};
